import Box from '@mui/material/Box';
import IconButton from '@mui/material/IconButton';
import FullscreenIcon from '@mui/icons-material/Fullscreen';
import VisualisationButton from '../VisualisationButton/VisualisationButton';

export default function ImageViewer(props) {
  const { space } = props;

  return (
    <Box
      data-testid="ImageViewer"
      sx={{
        height: 320,
        display: 'flex',
        alignItems: 'flex-start',
        justifyContent: 'flex-end',
        overflow: 'hidden',
        borderRadius: '8px',
        backgroundSize: 'cover',
        backgroundPosition: 'center center',
        backgroundImage: 'url(' + props.images[props.currentImage] + ')',
      }}>
      <VisualisationButton space={space} />
      <IconButton
        data-testid="ExpandButton"
        aria-label="fullscreen"
        style={{
          position: 'absolute',
        }}
        onClick={props.handleExpandClick}>
        <FullscreenIcon
          style={{
            borderRadius: '6px',
            backgroundColor: 'rgb(58, 62, 67)',
            color: '#fff',
          }}></FullscreenIcon>
      </IconButton>
    </Box>
  );
}
